import React, { useState } from 'react';
import HeaderComponent from '../../components/HeaderComponent';
import { Form, Layout, Input, Button, Select, message } from 'antd';
import { createNetworkDashboardUser } from '../../services/api/onboarding-requests';
import SidebarComponent from '../../components/sidebarComponent';

const AddUser = () => {
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    password: '',
    phone: '',
    email: '',
    role: 'user',
  });
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  const nameRegex = /^[a-zA-Z\s]*$/;
  const usernameRegex = /^[a-zA-Z0-9_]*$/;
  // const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const emailRegex = /^[a-zA-Z0-9._%+-]+@getvisitapp\.com$/; // Email should end with @getvisitapp.com
  const phoneRegex = /^\d{10}$/;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDropdownChange = (value) => {
    setFormData({ ...formData, ['role']: value });
  };
  const validateForm = () => {
    if (!nameRegex.test(formData.name)) {
      alert('Name is invalid. Only letters and spaces are allowed.');
      return false;
    }
    if (!usernameRegex.test(formData.username)) {
      alert(
        'Username is invalid. Only letters, numbers, and underscores are allowed.'
      );
      return false;
    }
    
    if (!emailRegex.test(formData.email)) {
      alert('Email is invalid. Please enter a valid email address.');
      return false;
    }
    if (!phoneRegex.test(formData.phone)) {
      alert('Phone number is invalid. Please enter a 10-digit phone number.');
      return false;
    }

    return true;
  };

  // const onSubmit = (e) => {
  //   e.preventDefault();
  //   console.log('sjsjs',e);
  // }

  const onSubmitDetails = (e) => {
    e.preventDefault();
    console.log('form data', formData);

    if (!validateForm()) {
      return;
    }
    createNetworkDashboardUser(formData)
      .then((res) => {
        if (res.body.message == 'success') {
          message.success('User Added Successfully');
        }
        if (res.body.message === 'serverError') {
          message.error(res.body.errorMessage);
        }
      })
      .catch((err) => {
        message.error(
          'This username, email or phoneNumber is already registered with us. Please try again with any other credentials.'
        );
      });
  };

  return (
    <Layout>
      <div>
        <HeaderComponent />
        <div style={{
          display: 'flex',
        }}>
          <div style={{ zIndex: 1000 }}>

            <SidebarComponent isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
          </div>
          <div style={{ width: '80%', alignItems: 'center' }}>

      <div >
        <div
          className="form-container"
          style={{
            padding: '20px',
            backgroundColor: '#fff',
            borderRadius: '5px',
            marginTop: '20px',
            marginLeft: '200px',
          }}
        >
          <Form onSubmit={onSubmitDetails}>
            <Form.Item label="Name" required>
              <Input
                placeholder="Name"
                name="name"
                onChange={handleInputChange}
                required
              ></Input>
            </Form.Item>
            <Form.Item label="User Name" required>
              <Input
                placeholder="username"
                name="username"
                onChange={handleInputChange}
                required
              ></Input>
            </Form.Item>
            <Form.Item label="Password" required>
              <Input.Password
                placeholder="username"
                name="password"
                onChange={handleInputChange}
                required
              ></Input.Password>
            </Form.Item>
            <Form.Item label="Phone" required>
              <Input
                placeholder="Enter Your Phone Number"
                name="phone"
                onChange={handleInputChange}
                required
              ></Input>
            </Form.Item>
            <Form.Item label="Email" required>
              <Input
                placeholder="Email"
                name="email"
                onChange={handleInputChange}
                required
              ></Input>
            </Form.Item>
            <Form.Item label="Select Role" required>
              <Select
                name="role"
                defaultValue={'user'}
                onChange={handleDropdownChange}
                required
              >
                <Select.Option name="role" value="admin">
                  Admin
                </Select.Option>
                <Select.Option name="role" value="user">
                  User
                </Select.Option>
              </Select>
            </Form.Item>
            <Form.Item style={{}}>
              <Button block type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
    </div></div></Layout>
  );
};

export default AddUser;
